@import 'apps/webcomponents/src/assets/widget-shared.scss';
@import 'apps/webcomponents/src/assets/color-helpers.scss';
@import 'apps/webcomponents/src/assets/common.scss';
@import 'apps/webcomponents/src/assets/style-helpers.scss';

:host {
  background-color: var(--white-layout-302-level-1-elevation);
  color: var(--main-titles-inputs-600);
}

.wrapper {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
}

#managedEndpointsActions {
  display: flex;
  gap: var(--spacer);

  gz-button {
    max-width: 32px;
    &::part(button),
    &::part(button-text) {
      padding: 0;
      max-width: 32px;
      min-width: 32px;
    }
  }
}

.item {
  border-left: 1px solid var(--chart-101-pressed-dividers);
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  flex-direction: column;
  margin: 0 var(--spacer);

  &.icon-action-buttons {
    flex-direction: row;
    justify-content: flex-start;
    gap: calc(var(--spacer) * 4);
    align-items: end;

    .item-content {
      order: 2;
    }

    .icon {
      font-size: 15px;
    }
  }

  &.is-empty {
    div#managedEndpointsEmpty {
      display: flex;
      margin: 0 auto;
      gap: 0;
    }
  }

  &.is-endpoints-empty {
    flex: 2;

    div#managedEndpointsEmpty {
      margin: 0;
      gap: calc(var(--spacer) * 4);
    }

    .item-content {
      width: 100%;
      align-items: flex-start;

      .widget-empty {
        display: none !important;
      }
    }
  }

  div#managedEndpointsEmpty {
    flex-flow: row;
    align-self: flex-start;
    display: none;

    #managedEndpointsTextContainer {
      display: flex;
      flex-flow: row;
      align-items: center;
    }
  }

  div#managedEndpointsButtons {
    display: flex;
    flex-flow: row;
    gap: calc(var(--spacer) * 2);
    align-items: end;
  }

  &:first-of-type {
    border-left: none;
  }

  &.is-loading {
    .item-content {
      .item-values {
        opacity: 0;
        min-height: 40px;
      }
      .widget-empty {
        display: none;
      }
      .widget-loading {
        display: block;
      }
      #managedEndpointsActions {
        display: none;
      }
    }
  }

  &.is-empty {
    &[gz-overview='managedEndpoints'] {
      .item-content {
        .item-values {
          display: none;
        }
      }
    }
    .item-content {
      .widget-loading {
        display: none;
      }
      .widget-empty {
        display: block;
      }
    }
  }

  .item-content {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  .widget-loading {
    height: 21px;
    top: 50%;
    min-width: 170px;
    display: none;
  }

  .item-values {
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 1;
  }

  &--title {
    text-align: center;
    &.widget-title {
      margin-bottom: 0;
      padding-bottom: var(--spacer);
    }
  }

  &--value {
    font-size: var(--display-large-size);
    line-height: 1;
    color: var(--main-titles-inputs-600);

    .error {
      color: var(--chart-101-pressed-dividers);
    }
  }

  &--delta {
    font-size: var(--body-size);
    color: var(--grey-layout-200-disabled);
    margin-left: calc(2 * var(--spacer));
    font-family: var(--font-family-secondary-mono);
    font-weight: bold;

    &.success {
      color: var(--green-layout-101-primary-green);
    }

    &.danger {
      color: var(--red-layout-300-primary);
    }
  }

  &.is-missing-license {
    display: none;
  }
}

// TBD: responsive styles
@media screen and (max-width: 1366px) {
  .item {
    &--value {
      font-size: var(--exec-summ-overview-font-size-big);
    }

    &.is-empty {
      div#managedEndpointsEmpty {
        gap: 0;
      }
    }

    &.is-endpoints-empty {
      div#managedEndpointsEmpty {
        flex-wrap: wrap;
        gap: calc(var(--spacer) + 2px);
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .item {
    &--value {
      font-size: var(--exec-summ-overview-font-size-small);
    }
    div#managedEndpointsEmpty {
      gap: 0;
      gz-text {
        line-height: 1;
      }
    }
  }
}

.item {
  &.is-loading,
  &.is-error,
  &.is-empty {
    .has-action {
      cursor: default;
      pointer-events: none;
    }
  }
}

.item:not(.is-loading):not(.is-error):not(.is-empty) {
  .has-action {
    cursor: pointer;
    transition: color 0.3s ease-in-out;

    &.drilldown-binder-hover {
      color: var(--blue-layout-300-active);
    }

    &.drilldown-binder-active {
      color: var(--blue-layout-300-active);
    }

    &.drilldown-binder-focus {
      outline: none;
      color: var(--blue-layout-500-focus);
    }
  }
}

:host([data-display-mode='pdf']) {
  .wrapper {
    .item {
      .item-content {
        justify-content: center;
        .item-values {
          font-size: calc(var(--display-large-size) - 10px);
          .item--delta {
            font-weight: 700;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1366px) {
    .item {
      &--value {
        font-size: var(--display-large-size);
      }
    }
  }

  .display-2 {
    font-size: var(--body-size);
  }
  .body-copy {
    font-size: var(--body-size-xsmall);
  }
}
